import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img5.jpg";
import projImg5 from "../assets/img/project-img6.jpg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Tripzky",
      description: "Design & Development",
      imgUrl: projImg1,
      url: "https://tripzky-web.netlify.app/",
    },
    {
      title: "Gaming Website",
      description: "Design & Development",
      imgUrl: projImg2,
      url: "https://code-craze-2024.netlify.app/",
    },
    {
      title: "Cafe Website",
      description: "Design & Development",
      imgUrl: projImg3,
      url: "https://pedlers-inn-cafe-1.netlify.app/",
    },
    {
      title: "CV Creation",
      description: "Design & Development",
      imgUrl: projImg4,
      url: "https://cv-web-new.netlify.app/",
    },
    {
      title: "Car Service Web",
      description: "Design & Development",
      imgUrl: projImg5,
      url: "https://asherifiledcom.netlify.app/",
    },
    {
      title: "Shopping Website",
      description: "Design & Development",
      imgUrl: projImg3,
      url: "https://e-commerce-web-cara.netlify.app/",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>I have developed a diverse portfolio of projects, including 3 React-based projects showcasing my expertise in building dynamic and interactive web applications. Additionally, I have completed a full-stack project, integrating front-end and back-end technologies for a complete web solution. My experience also includes 4 HTML, CSS, and JavaScript projects, where I honed my skills in creating responsive, user-friendly websites with clean design and functionality.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
